export default __webpack_public_path__ + "static/media/delete_session_icon.74537f3f.svg";